import {
  COMPONENT_TABLE
} from "../constants/typeConstants";
import common from "./common";
/**
 * factory function to produce CheckBox Component Object
 * @param {String} name
 * @param {Array} children array
 */
export default function (name = "Table Layout", children = []) {
  let obj = {
    name: name,
    type: COMPONENT_TABLE,
    children: children
  };
  return Object.assign(obj, common);
}